function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { GiHamburgerMenu } from 'react-icons/gi';
import './MenuSelect.css';

function useComponentVisible(initialIsVisible) {
  var _useState = useState(initialIsVisible),
      _useState2 = _slicedToArray(_useState, 2),
      isComponentVisible = _useState2[0],
      setIsComponentVisible = _useState2[1];

  var ref = useRef(null);

  var handleHideDropdown = function handleHideDropdown(event) {
    setIsComponentVisible(false);
  };

  var handleClickOutside = function handleClickOutside(event) {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsComponentVisible(false);
    }
  };

  useEffect(function () {
    document.addEventListener("keydown", handleHideDropdown, true);
    document.addEventListener("click", handleClickOutside, true);
    return function () {
      document.removeEventListener("keydown", handleHideDropdown, true);
      document.removeEventListener("click", handleClickOutside, true);
    };
  });
  return {
    ref: ref,
    isComponentVisible: isComponentVisible,
    setIsComponentVisible: setIsComponentVisible
  };
}

var MenuSelect = function MenuSelect(props) {
  var _useComponentVisible = useComponentVisible(false),
      ref = _useComponentVisible.ref,
      isComponentVisible = _useComponentVisible.isComponentVisible,
      setIsComponentVisible = _useComponentVisible.setIsComponentVisible;

  var containerStyle = {
    display: 'flex'
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    style: containerStyle
  }, isComponentVisible && /*#__PURE__*/React.createElement("button", {
    className: "menu-select-btn"
  }, /*#__PURE__*/React.createElement(GiHamburgerMenu, null), /*#__PURE__*/React.createElement("div", {
    className: "menu-select"
  }, /*#__PURE__*/React.createElement("ul", null, props.options.map(function (option, i) {
    return /*#__PURE__*/React.createElement("li", {
      key: i,
      onClick: function onClick() {
        setIsComponentVisible(false);
        option[1]();
      }
    }, option[0]);
  })))), !isComponentVisible && /*#__PURE__*/React.createElement("button", {
    className: "menu-select-btn",
    onClick: function onClick() {
      return setIsComponentVisible(true);
    }
  }, /*#__PURE__*/React.createElement(GiHamburgerMenu, null)));
};

export default MenuSelect;